import { Severity } from '../../enums/Severity';
import { Details } from './valueObjects/Details';

export class Issue {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly number: number,
    private readonly description: string | null,
    private readonly level: Severity,
    private readonly inSlotsPresent: number,
    private readonly consequence: Details
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getNumber() {
    return this.number;
  }

  getDescription() {
    return this.description;
  }

  getLevel() {
    return this.level;
  }

  getInSlotsPresent() {
    return this.inSlotsPresent;
  }

  getConsequence() {
    return this.consequence;
  }
}
